import { Dto, DtoWithId } from "@mango/core";
import { Instrument } from "./instrument";


@Dto({fullName: "CIJBorculo.Logic.kpCertificaat"})
export class kpCertificaat extends DtoWithId {
	instrument: Instrument;
	certificaat: string;
	datumKalibratie: Date;
	justering: boolean;
	afkeur: boolean;
	status: string;

	certificaat_Werkstandaard1: String;
	certificaat_Werkstandaard2: String;
	certificaat_Werkstandaard3: String;
	certificaat_Werkstandaard4: String;
	certificaat_Werkstandaard5: String;
	certificaat_Werkstandaard6: String;

	hasWerkstandaard1: boolean;
	hasWerkstandaard2: boolean;
	hasWerkstandaard3: boolean;
	hasWerkstandaard4: boolean;
	hasWerkstandaard5: boolean;
	hasWerkstandaard6: boolean;
	
	werkstandaard1: string;
	werkstandaard2: string;
	werkstandaard3: string;
	werkstandaard4: string;
	werkstandaard5: string;
	werkstandaard6: string;
	
}